import _ from "lodash"
import { diff } from '../lib/render-object'
import { ChangeProps } from './change-renderer'
import codeService from 'data/codes'

const mapper = (text) => {
  return {
    folderpath: 'Folder Path',
  }[text] || _.startCase(text)
}

const resource_m = (text) => {
  return {
  }[text] || _.startCase(text)
}

type EventChange = {
  event: string
  data: {
    destination?: {
      folderid?: number
    }
    source?: {
      folderid?: number
      propertycode?: string
      propertyid?: number
      property: string
    }
    target?: {
      folderid?: number
      propertycode?: string
      propertyid?: number
      property: string
    }
  }
}
const alwaysDrop = ['externalreference', 'organizationid']

export const diffif = (props: ChangeProps) => {
  if (props.method !== 'MARK') return null
  return () => {
    const change = JSON.parse(props.change) as EventChange
    delete change.data.destination?.folderid
    delete change.data.source?.folderid
    if(change.data.source?.propertycode) change.data.source.property = change.data.source.propertycode
    delete change.data.source?.propertycode
    delete change.data.source?.propertyid
    delete change.data.target?.folderid
    if(change.data.target?.propertycode) change.data.target.property = change.data.target.propertycode
    delete change.data.target?.propertycode
    delete change.data.target?.propertyid

    return {
      atRest: _.startCase(change.event),
      diffs: diff(null, change.data, mapper, null, alwaysDrop),
      ...props
    }
  }
}